// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_math-sign.js
// module id = 204
// module chunks = 2